import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  approved: () => i18n.t(i18nKeys.common__approved),
  pending: () => i18n.t(i18nKeys.common__pending),
  approvedText: () => i18n.t(i18nKeys.instantDashStatus__approvedText),
  pendingText: () => i18n.t(i18nKeys.instantDashStatus__pendingText),
  yourAccountStatus: () =>
    i18n.t(i18nKeys.instantDashStatus__yourAccountStatus),
  howToDash: () => i18n.t(i18nKeys.instantDashHelp__howToDash),
  helpArticles: () => i18n.t(i18nKeys.instantDashHelp__helpArticles),
  seeAll: () => i18n.t(i18nKeys.instantDashHelp__seeAll),
  articleHowToDash: () => i18n.t(i18nKeys.instantDashHelp__articleHowToDash),
  articleScheduling: () => i18n.t(i18nKeys.instantDashHelp__articleScheduling),
  articleDirectDeposit: () =>
    i18n.t(i18nKeys.instantDashHelp__articleDirectDeposit),
}
